import { render, staticRenderFns } from "./ModalCurso.vue?vue&type=template&id=38f797f0&scoped=true"
import script from "./ModalCurso.vue?vue&type=script&lang=js"
export * from "./ModalCurso.vue?vue&type=script&lang=js"
import style0 from "./ModalCurso.vue?vue&type=style&index=0&id=38f797f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f797f0",
  null
  
)

export default component.exports